const oficiales = [
  { cargo: "Presidente", nombre: "Francisco Idelfonso Diaz Galarza" },
  { cargo: "Ex-Presidente Inm.·.", nombre: "Guillermo Miguel Gilbert Alva" },
  { cargo: "Vice-Presidente", nombre: "Rubén Antonio Velarde Flores" },
  { cargo: "Orador", nombre: "Efraín Bonifacio Gonzales Salcedo" },
  { cargo: "Secretario", nombre: "Vacante", vacante: true }
];

const ConsejoSimbolismo = () => {
  return (
    <div className="min-h-screen bg-[#050505] text-white selection:bg-[#C5A059] selection:text-[#050505] font-sans pt-24 flex flex-col">
      
      {/* Hero Section */}
      <section className="relative w-full pt-32 pb-16 md:pt-40 md:pb-24 flex flex-col items-center justify-center overflow-hidden border-b border-white/5">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
          style={{ backgroundImage: "url('https://images.unsplash.com/photo-1532153955177-f59af40d6472?q=80&w=2000&auto=format&fit=crop')" }} // Imagen de libros/estudio
        ></div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/90 via-[#050505]/60 to-[#050505]"></div>

        <div className="relative z-10 text-center px-4 w-full max-w-4xl mx-auto">
          <p className="text-[#C5A059] tracking-[0.4em] uppercase text-xs md:text-sm font-light mb-4 animate-fade-in">
            Instrucción Masónica
          </p>
          <h1 className="font-serif text-3xl md:text-5xl lg:text-6xl font-normal text-white tracking-tight animate-fade-in [animation-delay:0.3s] drop-shadow-lg mb-4">
            Consejo del Simbolismo
          </h1>
          <h2 className="font-serif text-xl md:text-2xl italic font-light text-gray-300 animate-fade-in [animation-delay:0.5s]">
            Rito Escocés Antiguo y Aceptado
          </h2>
        </div>
      </section>

      {/* Sección 1: Reseña Histórica */}
      <section className="relative z-20 max-w-[90rem] mx-auto px-6 lg:px-12 py-16 md:py-24">
        <div className="max-w-4xl mx-auto text-center border-b border-white/10 pb-16">
          <span className="text-[#C5A059] text-[10px] tracking-[0.3em] uppercase mb-4 block">Propósito y Función</span>
          <p className="text-gray-300 font-light leading-relaxed text-lg md:text-xl text-justify md:text-center">
            El Consejo del Simbolismo del Rito Escocés, es el organismo consultor del Gran Maestro en lo concerniente a liturgias y ceremonias del Rito Escocés Antiguo y Aceptado, y es de su exclusiva incumbencia dictaminar sobre ellas y sus modificaciones, al igual que impartir instrucción en las RR.·.LL.·.SS.·. que trabajan bajo ese rito.
          </p>
        </div>
      </section>

      {/* Sección 2: Cuadro de Dignidades y Oficiales */}
      <section className="relative z-20 max-w-[90rem] mx-auto px-6 lg:px-12 pb-24 flex-grow w-full">
        
        <div className="mb-12 flex flex-col md:flex-row justify-between md:items-end gap-4">
          <div>
            <span className="text-[#C5A059] text-[10px] tracking-[0.3em] uppercase mb-2 block">Directorio</span>
            <h3 className="font-serif text-3xl md:text-4xl text-white font-normal">Cuadro de DD.·. y OO.·.</h3>
          </div>
          <div className="text-left md:text-right">
            <p className="text-gray-400 text-xs tracking-widest uppercase">Periodo 2025 - 2027 E.·.V.·.</p>
            <p className="text-[#C5A059] text-[10px] tracking-widest uppercase border border-[#C5A059]/30 px-2 py-1 mt-2 inline-block">Decreto 143-414 GLP</p>
          </div>
        </div>

        {/* Grilla de Oficiales */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6">
          
          {/* Presidente destacado */}
          <div className="bg-gradient-to-br from-[#0a0a0a] to-[#111111] border-t-2 border-[#C5A059] p-6 md:p-8 shadow-xl md:col-span-2 lg:col-span-1">
            <span className="text-[#C5A059] text-[10px] tracking-[0.2em] uppercase block mb-3 font-semibold">{oficiales[0].cargo}</span>
            <p className="text-gray-500 text-[10px] tracking-widest uppercase mb-1">R.·. H.·.</p>
            <h4 className="font-serif text-2xl text-white">{oficiales[0].nombre}</h4>
          </div>
          
          {/* Ex-Presidente */}
          <div className="bg-[#0a0a0a] border border-white/5 p-6 md:p-8 hover:border-[#C5A059]/30 transition-colors">
            <span className="text-[#C5A059] text-[10px] tracking-[0.2em] uppercase block mb-3 font-semibold">{oficiales[1].cargo}</span>
            <p className="text-gray-500 text-[10px] tracking-widest uppercase mb-1">R.·. H.·.</p>
            <h4 className="font-serif text-xl md:text-2xl text-white">{oficiales[1].nombre}</h4>
          </div>

          {/* Vice-Presidente */}
          <div className="bg-[#0a0a0a] border border-white/5 p-6 md:p-8 hover:border-[#C5A059]/30 transition-colors">
            <span className="text-[#C5A059] text-[10px] tracking-[0.2em] uppercase block mb-3 font-semibold">{oficiales[2].cargo}</span>
            <p className="text-gray-500 text-[10px] tracking-widest uppercase mb-1">R.·. H.·.</p>
            <h4 className="font-serif text-xl md:text-2xl text-white">{oficiales[2].nombre}</h4>
          </div>

          {/* Resto de Oficiales */}
          {oficiales.slice(3).map((oficial, idx) => (
            <div key={idx + 3} className="bg-[#050505] border border-white/5 p-6 hover:bg-white/[0.02] transition-colors">
              <span className="text-gray-400 text-[10px] tracking-[0.2em] uppercase block mb-3 font-semibold border-b border-white/5 pb-2 inline-block">{oficial.cargo}</span>
              {!oficial.vacante && <p className="text-gray-600 text-[10px] tracking-widest uppercase mb-1">R.·. H.·.</p>}
              <h4 className={`font-serif text-lg ${oficial.vacante ? 'text-gray-600 italic' : 'text-gray-300'}`}>
                {oficial.nombre}
              </h4>
            </div>
          ))}

        </div>

      </section>

    </div>
  );
};

export default ConsejoSimbolismo;